/* eslint-disable arrow-parens */
/* eslint-disable implicit-arrow-linebreak */

/**
 * The global state selectors
 */

import { createSelector } from 'reselect'
import { initialState } from './reducer'

const selectCourseActivity = (state) => state.courseActivityStore || initialState

const makeSelectCourseActivity = () =>
  createSelector(
    selectCourseActivity,
    (state) => state
  )

const makeSelectCourseActivityUserList = () =>
  createSelector(
    selectCourseActivity,
    (state) => ({
      ...state.userList,
      data: state.userList.data.map((user) => ({
        key: user.userId,
        value: user.userId,
        label: user.fullName
      }))
    })
  )

const makeSelectStudyCourseTime = () =>
  createSelector(
    selectCourseActivity,
    (state) => state.studyCourseTime
  )

const makeSelectStudyCourseHistory = () =>
  createSelector(
    selectCourseActivity,
    (state) => state.studyCourseHistory
  )

const makeSelectCourseRankingAll = () =>
  createSelector(
    selectCourseActivity,
    (state) => state.courseRankingAll
  )

const makeSelectCourseRankingNissoken = () =>
  createSelector(
    selectCourseActivity,
    (state) => state.courseRankingNissoken
  )

const makeSelectCourseRankingCompany = () =>
  createSelector(
    selectCourseActivity,
    (state) => state.courseRankingCompany
  )

export {
  selectCourseActivity,
  makeSelectCourseActivity,
  makeSelectCourseActivityUserList,
  makeSelectStudyCourseTime,
  makeSelectStudyCourseHistory,
  makeSelectCourseRankingAll,
  makeSelectCourseRankingNissoken,
  makeSelectCourseRankingCompany
}
